// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemProps } from "@insite/mobius/GridItem";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import xOrderInformationStyles from "@sc/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { rfqConfirmationDetailsStyles } from "@sc/Overrides/Widgets/RfqConfirmation/RfqConfirmationDetails";
import { mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const gridItemValue: GridItemProps = { width: [12, 6, 6, 6, 6] };

rfqConfirmationDetailsStyles.detailsGridContainer = {
    gap: 0,
    css: css`
        margin-bottom: 20px;
    `,
};
rfqConfirmationDetailsStyles.jobNameGridItem = {
    ...gridItemValue,
};
rfqConfirmationDetailsStyles.salesRepGridItem = {
    ...gridItemValue,
};
rfqConfirmationDetailsStyles.statusGridItem = {
    ...gridItemValue,
};
rfqConfirmationDetailsStyles.dateGridItem = {
    ...mergeWithCss(gridItemValue, {
        css: css`
            ${TypographyStyle} {
                font-size: 14px;
            }
        `,
    }),
};
rfqConfirmationDetailsStyles.customerGridItem = {
    ...gridItemValue,
};
rfqConfirmationDetailsStyles.shipToGridItem = {
    ...gridItemValue,
};
rfqConfirmationDetailsStyles.notesGridItem = {
    ...gridItemValue,
};

rfqConfirmationDetailsStyles.jobNameHeadingAndText = {
    ...xOrderInformationStyles.headingAndTextStyles,
};
rfqConfirmationDetailsStyles.salesRepHeadingAndText = {
    ...xOrderInformationStyles.headingAndTextStyles,
};
rfqConfirmationDetailsStyles.statusHeadingAndText = {
    ...xOrderInformationStyles.headingAndTextStyles,
};
rfqConfirmationDetailsStyles.dateLabelText = {
    ...mergeWithCss(xOrderInformationStyles.labelWithDots, {
        css: css`
            margin-bottom: 4px;
        `,
    }),
};
rfqConfirmationDetailsStyles.customerHeadingAndText = {
    ...xOrderInformationStyles.headingAndTextStyles,
};
rfqConfirmationDetailsStyles.shipToHeadingAndText = {
    ...xOrderInformationStyles.headingAndTextStyles,
};
rfqConfirmationDetailsStyles.notesHeadingAndText = {
    ...xOrderInformationStyles.headingAndTextStyles,
};
